import SlDialog from "@shoelace-style/shoelace/dist/react/dialog";

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const KioskInfoDialog = ({ open, onClose, selectedBorneData, t }) => {
  return (
    <SlDialog
      label="Information Kiosk"
      open={open}
      onSlAfterHide={onClose}
      style={{ "--width": "60vw" }}
    >
      <div style={{ display: "flex", flex: 1 }}>
        <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
          <div>
            <span style={{ fontSize: 20 }}>Kiosk </span> - {selectedBorneData?.doc?.borne?.name}
          </div>
          <div>
            <span style={{ fontSize: 20 }}> {t("located_at")} </span>
            {selectedBorneData?.doc?.borne?.location?.address}
          </div>
        </div>
        <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
          <div>
            <span style={{ fontSize: 20 }}>{t("funds_collectedBy_Kiosk")}</span> :{" "}
            {formatCurrency(selectedBorneData?.total)} $
          </div>
          <div>
            <span style={{ fontSize: 20 }}>{t("location")}</span> :{" "}
            {selectedBorneData?.doc?.borne?.location?.location_name}
          </div>
        </div>
      </div>
    </SlDialog>
  );
};

export default KioskInfoDialog;
